/* src/app/components/dashboard-config/dashboard-config.component.css */
/*# sourceMappingURL=dashboard-config.component.css.map */
